import { getCloudinaryImageUrl } from '@utils/images'
import Image from 'next/image'

const Module5 = (props: any) => {
  // Common text styles based on Figma
  const textBaseStyle = 'font-bold leading-[0.9em] tracking-[-0.05em] uppercase text-[25px]'
  const textSmallStyle = 'font-bold uppercase leading-[0.9em] text-[16px] tracking-[-0.05em]'

  return (
    <div className='flex flex-col items-center p-2 space-y-6 font-abcd bg-white'>
      <div className='snap-section-start hide-floating-logos relative top-[10px]' />
      {/* Text Block 1 - Updated styles */}
      <div className='w-full text-left'>
        <p className={`${textBaseStyle} `}>{props.block5Heading1}</p>
        <p className={`${textSmallStyle} `}>{props.block5Heading1Brief}</p>
      </div>

      {/* Image 1 - Updated aspect ratio */}
      <div className='w-full aspect-[374/313] relative !-mt-0'>
        {props?.block5Image1?.data?.attributes?.url && (
          <Image
            src={getCloudinaryImageUrl(props?.block5Image1?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto')}
            alt=''
            layout='fill'
            objectFit='cover'
          />
        )}
      </div>

      {/* Text Block 2 - Updated styles and alignment */}
      <div className='w-full text-right !-mt-0'>
        <p className={`${textBaseStyle} text-[25px]`}>{props.block5Heading2}</p>
        <p className={`${textSmallStyle}`}>{props.block5Heading2Brief}</p>
      </div>

      {/* Image 2 - Updated aspect ratio */}
      <div className='w-full aspect-[374/313] relative !-mt-0'>
        {props?.block5Image2?.data?.attributes?.url && (
          <Image
            src={getCloudinaryImageUrl(props?.block5Image2.data.attributes.url, 'q_auto,dpr_auto,f_auto,w_968')}
            alt=''
            layout='fill'
            objectFit='cover'
          />
        )}
      </div>
    </div>
  )
}

export default Module5
